import React from "react";

export default function Campaigns() {
  return <div>campaigns</div>;
}
